{
  "TEAMS_SETTINGS": {
    "NEW_TEAM": "Izradi novi tim",
    "HEADER": "Timovi",
    "LOADING": "Dohvaćanje timova",
    "DESCRIPTION": "Timovi omogućuju organizaciju agenata u grupe prema njihovim odgovornostima. Agent može pripadati u više timova. Razgovore možete dodijeliti određenim timovima.",
    "LEARN_MORE": "Saznajte više o timovima",
    "LIST": {
      "404": "U ovom računu nema izrađenih timova.",
      "EDIT_TEAM": "Uredi tim",
      "NONE": "Nijedno"
    },
    "CREATE_FLOW": {
      "CREATE": {
        "TITLE": "Izradi novi tim",
        "DESC": "Dodajte naziv i opis novom timu."
      },
      "AGENTS": {
        "BUTTON_TEXT": "Dodaj agente u tim",
        "TITLE": "Dodaj agente u tim – {teamName}",
        "DESC": "Dodajte agente u novi tim. Tako možete zajednički raditi na razgovorima i primati obavijesti o novim događajima u istom razgovoru."
      },
      "WIZARD_CREATE": {
        "TITLE": "Izradi",
        "BODY": "Izradite novi tim agenata."
      },
      "WIZARD_ADD_AGENTS": {
        "TITLE": "Dodaj agente",
        "BODY": "Dodajte agente u tim."
      },
      "WIZARD_FINISH": {
        "TITLE": "Završi",
        "BODY": "Sve je spremno!"
      }
    },
    "EDIT_FLOW": {
      "CREATE": {
        "TITLE": "Uredite podatke tima",
        "DESC": "Uredite naziv i opis tima.",
        "BUTTON_TEXT": "Ažuriraj tim"
      },
      "AGENTS": {
        "BUTTON_TEXT": "Ažuriraj agente u timu",
        "TITLE": "Dodaj agente u tim – {teamName}",
        "DESC": "Dodajte agente u tim. Svi dodani agenti primit će obavijest kada se razgovor dodijeli ovom timu."
      },
      "EDIT_WIZARD_DETAILS": {
        "TITLE": "Podaci tima",
        "ROUTE": "settings_teams_edit",
        "BODY": "Promijenite naziv, opis i ostale podatke."
      },
      "EDIT_WIZARD_AGENTS": {
        "TITLE": "Uredi agente",
        "ROUTE": "settings_teams_edit_members",
        "BODY": "Uredite agente u timu."
      },
      "EDIT_WIZARD_FINISH": {
        "TITLE": "Završi",
        "ROUTE": "settings_teams_edit_finish",
        "BODY": "Sve je spremno!"
      }
    },
    "TEAM_FORM": {
      "ERROR_MESSAGE": "Podatke tima nije moguće spremiti. Pokušajte ponovno."
    },
    "AGENTS": {
      "AGENT": "AGENT",
      "EMAIL": "E-pošta",
      "BUTTON_TEXT": "Dodaj agente",
      "ADD_AGENTS": "Dodavanje agenata u tim...",
      "SELECT": "odaberi",
      "SELECT_ALL": "odaberi sve agente",
      "SELECTED_COUNT": "Odabrano agenata: {selected} od {total}."
    },
    "ADD": {
      "TITLE": "Dodaj agente u tim – {teamName}",
      "DESC": "Dodajte agente u novi tim. Tako možete zajednički raditi na razgovorima i primati obavijesti o novim događajima u istom razgovoru.",
      "SELECT": "odaberi",
      "SELECT_ALL": "odaberi sve agente",
      "SELECTED_COUNT": "Odabrano agenata: {selected} od {total}.",
      "BUTTON_TEXT": "Dodaj agente",
      "AGENT_VALIDATION_ERROR": "Odaberite barem jednog agenta."
    },
    "FINISH": {
      "TITLE": "Vaš tim je spreman!",
      "MESSAGE": "Sada možete zajednički raditi na razgovorima kao tim. Uspješnu podršku! ",
      "BUTTON_TEXT": "Završi"
    },
    "DELETE": {
      "BUTTON_TEXT": "Izbriši",
      "API": {
        "SUCCESS_MESSAGE": "Tim je uspješno izbrisan.",
        "ERROR_MESSAGE": "Tim nije moguće izbrisati. Pokušajte ponovno."
      },
      "CONFIRM": {
        "TITLE": "Jeste li sigurni da želite izbrisati tim?",
        "PLACE_HOLDER": "Upišite {teamName} za potvrdu",
        "MESSAGE": "Brisanjem tima uklonit će se dodjela tima iz razgovora dodijeljenih ovom timu.",
        "YES": "Izbriši ",
        "NO": "Odustani"
      }
    },
    "SETTINGS": "Postavke",
    "FORM": {
      "UPDATE": "Ažuriraj tim",
      "CREATE": "Izradi tim",
      "NAME": {
        "LABEL": "Naziv tima",
        "PLACEHOLDER": "Primjer: Prodaja, Korisnička podrška"
      },
      "DESCRIPTION": {
        "LABEL": "Opis tima",
        "PLACEHOLDER": "Kratak opis ovog tima."
      },
      "AUTO_ASSIGN": {
        "LABEL": "Dopusti automatsku dodjelu za ovaj tim."
      },
      "SUBMIT_CREATE": "Izradi tim"
    }
  }
}
